import { Component, Input } from '@angular/core';

import { ModalBaseDirective } from '$core/base/_modal.component';

@Component({
  selector: 'app-confirm-delete-modal',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss'],
})
export class ConfirmDeleteModalComponent extends ModalBaseDirective {
  @Input() public img = 'remove';
  @Input() public title = 'DELETE';
  @Input() public alt = 'DELETE';
  @Input() public cancelBtnClass = 'button--text';
  @Input() public submitBtnClass = 'button--filled';
  @Input() public submitBtnEvent = 'delete';
  @Input() public submitBtnText = 'DELETE';
  @Input() public cancelBtnText = 'CANCEL';
  @Input() public subTitle = '';
  @Input() public imagePath = 'assets/img/icons/remove.svg';
}
